import { cn } from '@/lib/utils';

const TYPE_COLORS: Record<string, string> = {
  claude_md: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  adr: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  spec_proposal: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  spec_requirement: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  spec_tasks: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  spec_current: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  readme: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  architecture: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  documentation: 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300',
  generated_wiki: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
  markdown: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
};

const TYPE_LABELS: Record<string, string> = {
  claude_md: 'CLAUDE',
  adr: 'ADR',
  spec_proposal: 'Proposal',
  spec_requirement: 'Spec',
  spec_tasks: 'Tasks',
  spec_current: 'Spec',
  readme: 'README',
  architecture: 'Arch',
  documentation: 'Docs',
  generated_wiki: 'AI Wiki',
  markdown: 'MD',
};

export function DocTypeBadge({ type }: { type: string }) {
  return (
    <span className={cn(
      'px-1.5 py-0.5 rounded text-[10px] font-medium uppercase shrink-0',
      TYPE_COLORS[type] || TYPE_COLORS.markdown,
    )}>
      {TYPE_LABELS[type] || type}
    </span>
  );
}
